import { useGetQuery } from "slices/api";
import { FIRE_SAFETY_BUILDING_OBSERVATION } from "tagTypes";

export const useGetAllTenantsQuery = (buildingInformationId, query = {}) =>
  useGetQuery({
    endpoint: `/floor-wise-tenant/${buildingInformationId}`,
    query,
    tags: [FIRE_SAFETY_BUILDING_OBSERVATION],
  });
